import script from "./TitleRelatedTitles.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleRelatedTitles.vue?vue&type=script&setup=true&lang=js"

import "./TitleRelatedTitles.vue?vue&type=style&index=0&id=1e5d0f94&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e5d0f94"]])

export default __exports__